import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core";
import { dateMiladiToShamsi } from "../../../../../method/date";
import CardLoading from "./skeetonLoading";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes as actionTypesPost } from "../../../../../../redux/post/selectPost";

let responsiveLength = "1000";

let useStyles = makeStyles((theme) => ({
    root: {
        width: 300,
        // width: '100%',
        position: 'relative',
        margin: '20px 0px',
        // [theme.breakpoints.down('665')]: {
        //     width: 260,
        // },
        [theme.breakpoints.down('700')]: {
            width: '100%',
        },
    },
    title: {
        fontSize: 20,
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
        [theme.breakpoints.down('1500')]: {
            fontSize: 20,
        },
        [theme.breakpoints.down('500')]: {
            whiteSpace: 'normal',
            width: '100%',
            margin: 'auto',
            textAlign: 'center'
        }
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        [theme.breakpoints.down('1135')]: {
            top: -10,
            display: 'none'
        },
        [theme.breakpoints.down(responsiveLength)]: {
            top: -10,
            display: 'none'
        }
    },
    rootList: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: 100,
        backgroundColor: '#FAF9FC',
        borderRadius: 5,
        margin: '10px 0px',

    },
    contentList: {
        width: '60%',
        padding: "5px 10px",

    },
    gridImageList: {
        width: '40%',
        maxHeight: 90,
        overflow: 'hidden',
        '& img': {
            width: '100%',
            height: '100%',
            maxWidth: 200,
        },
        [theme.breakpoints.down('700')]: {
            width: '30%',
        },
    },

    titleList: {
        fontSize: 16,
        marginBottom: 7,
    },
    descList: {
        fontSize: 14,
        color: '#969696',
        marginBottom: 0,
    },
    btnsLink: {
        fontSize: 18,
        marginTop: 10,
        cursor: 'pointer',
        [theme.breakpoints.down('500')]: {
            textAlign: 'center',
            marginTop: 20,
        },
    },
    iconArrowLeft: {
        marginTop: 5,
        marginLeft: 10,
    }
}))

export default function Index({ data, loading, size, images }) {

    let classes = useStyles();
    let dispatch = useDispatch();


    function setData() {
        let national = document?.getElementById('ctl00_ContentPlaceHolder1_tbIDNo')
        let phone = document?.getElementById('ctl00_ContentPlaceHolder1_tbMobileNo')
        let state = document?.getElementById('ctl00_ContentPlaceHolder1_ddlState')

        let day = document?.getElementById('ctl00_ContentPlaceHolder1_ddlBrDay')
        let month = document?.getElementById('ctl00_ContentPlaceHolder1_ddlBrMonth')
        let year = document?.getElementById('ctl00_ContentPlaceHolder1_tbBrYear')

        let dayMarry = document?.getElementById('ctl00_ContentPlaceHolder1_ddlMarryDay')
        let monthMarry = document?.getElementById('ctl00_ContentPlaceHolder1_ddlMarryMonth')
        let yearMarry = document?.getElementById('ctl00_ContentPlaceHolder1_tbMarrYear')


        national.value = '0024160164'
        phone.value = '09193350654'
        state.value = '24'

        day.value = '14'
        month.value = '07'
        year.value = '1374'

        dayMarry.value = '30'
        monthMarry.value = '08'
        yearMarry.value = '1402'

    }

    const handelRout = (path) => {
        if (!path) return;
        window.open(path, "_blank");
    }
    return (
        <div className={classes['root']}>
            <div>

                <div className={classes['line']} />
                <h3 className={classes['title']}>
                    {
                        data.title
                    }
                </h3>
            </div>
            <div>
                {
                    loading && (
                        <CardLoading />
                    )
                }
                {
                    loading && (
                        <CardLoading />
                    )
                }
                {
                    loading && (
                        <CardLoading />
                    )
                }
                {
                    !loading && (
                        <>
                            {
                                Object.keys(data.list)?.reverse()

                                    ?.filter((item, index) => (index <= size))?.map((item, index) => {
                                        return (
                                            <Card
                                                key={index}
                                                data={data.list[item]}
                                                images={images}
                                                keyImages={item}
                                            />
                                        )
                                    })
                            }
                        </>
                    )
                }
            </div>
            <div>
                <p className={classes['btnsLink']} onClick={() => handelRout(data?.linkCategory)} >
                    <span>
                        {`مشاهده همه مطالب`}
                    </span>
                    <img src='/assets/images/VectorRight.png' alt='' className={classes['iconArrowLeft']} />
                </p>
            </div>

        </div>
    )
}



function Card({ data, images, keyImages }) {

    let classes = useStyles();

    return (
        <a href={data?.link} target={'_blank'}>
            <div className={classes['rootList']}>
                <div className={classes['gridImageList']}>
                    {
                        images?.[keyImages] && (
                            <img src={images?.[keyImages] ? images?.[keyImages]?.body?.guid?.rendered : ''} alt="تصویر مطلب" />
                        )
                    }
                </div>
                <div className={classes['contentList']}>
                    <p className={classes['titleList']}>
                        {data?.title?.rendered?.replaceAll('&#8211;', ` `)}
                    </p>
                    <p className={classes['descList']}   >
                        {dateMiladiToShamsi(data?.date)}
                    </p>
                </div>
            </div>
        </a>
    )

}


